import { TAO_KOE } from './../libs';

const initGekForm = function() {
	const formEl = document.getElementById( 'gek-form' );
	if ( ! formEl ) {
		return;
	}

	const strlenCountEls = formEl.querySelectorAll( '.strlen-counter' );
	strlenCountEls.forEach( function( counterEl ) {
		const textareaEl = counterEl.parentElement.parentElement.querySelector( counterEl.dataset.field );
		textareaEl.addEventListener( 'input', function() {
			if ( textareaEl.maxLength ) {
				textareaEl.value = textareaEl.value.substr( 0, textareaEl.maxLength - 1 );
			}

			counterEl.innerHTML = textareaEl.value.length;
		} );
	} );

	const designSliderEl = formEl.querySelector( '.design-selector' );
	if ( designSliderEl ) {
		designSliderEl.addEventListener( 'move.sl', ( event ) => {
			const activeSlideEl = event.detail && event.detail.activeSlide;
			const activeRadioEl = activeSlideEl && activeSlideEl.querySelector( 'input[name=DESIGN_ID]' );
			if ( ! activeRadioEl ) {
				return;
			}

			formEl.querySelectorAll( '.design-id input[name=DESIGN_ID]' ).forEach( ( radioEl ) => {
				radioEl.checked = radioEl === activeRadioEl;
			} );
		} );
	}

	formEl.addEventListener( 'submit', function() {
		const spec = 'Geschenkkarte';
		const email = formEl.querySelector( 'input[name="MAIL_RECIPIENT"]' )?.value;

		TAO_KOE.Tracking.sendIdentifyEvent( spec, email, spec );
		window.SL_DY_TRACKING.sendIdentifyUser( email );
	} );

	// Email validation
	const inputEl = formEl.querySelector( 'input[name="MAIL_RECIPIENT"]' );
	inputEl.oninvalid = ( ev ) => {
		ev.preventDefault();

		const errorEl = document.getElementById( 'invalid-email' );
		errorEl.style.display = 'block';
	};

	// Set focusout event for price invalid input.
	const priceEls = formEl.querySelectorAll( 'input[name="PRICE"]' );
	priceEls.forEach( ( priceEl ) => {
		if ( priceEl instanceof HTMLInputElement ) {
			priceEl.addEventListener( 'blur', function() {
				priceEl.value = Math.max( priceEl.value, priceEl.min );
			} );

			priceEl.addEventListener( 'focusout', () => {
				if ( ! priceEl.checkValidity() ) {
					priceEl.reportValidity();
				}
			} );
		}
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initGekForm, { once: true } );
} else {
	initGekForm();
}
